import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-738e1dbb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-columns-style" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "flex-end mt_16" }
const _hoisted_4 = { class: "flex-center" }
const _hoisted_5 = { class: "columns-search-style flex-center cursor-pt" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.75 1.74984C1.75 1.59513 1.81146 1.44675 1.92085 1.33736C2.03025 1.22796 2.17862 1.1665 2.33333 1.1665H11.6667C11.8214 1.1665 11.9697 1.22796 12.0791 1.33736C12.1885 1.44675 12.25 1.59513 12.25 1.74984V3.7915C12.25 3.8835 12.2282 3.97418 12.1864 4.05615C12.1446 4.13811 12.0841 4.20904 12.0097 4.26313L9.04167 6.42175V10.4998C9.04167 10.6006 9.01558 10.6996 8.96595 10.7872C8.91632 10.8749 8.84484 10.9482 8.75846 11L5.84179 12.75C5.75327 12.8032 5.65225 12.8318 5.54903 12.8331C5.44581 12.8344 5.34409 12.8083 5.25426 12.7575C5.16443 12.7066 5.0897 12.6328 5.03771 12.5436C4.98573 12.4544 4.95833 12.3531 4.95833 12.2498V6.42175L1.99033 4.26342C1.91588 4.2093 1.8553 4.13833 1.81353 4.05631C1.77176 3.97429 1.74999 3.88355 1.75 3.7915V1.74984ZM2.91667 2.33317V3.49459L5.88467 5.65292C5.95912 5.70704 6.0197 5.77801 6.06147 5.86003C6.10324 5.94205 6.12501 6.03279 6.125 6.12484V11.2197L7.875 10.1697V6.12484C7.87503 6.03284 7.89682 5.94216 7.93859 5.8602C7.98036 5.77823 8.04092 5.7073 8.11533 5.65321L11.0833 3.49459V2.33317H2.91667Z",
    fill: "#505762"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.5418 11.0832H10.2085V9.9165H12.5418V11.0832Z",
    fill: "#505762"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.5413 8.75016H10.208V7.5835H12.5413V8.75016Z",
    fill: "#505762"
  })
], -1))
const _hoisted_7 = { style: {"margin-left":"4px"} }

import { t, lang } from '@/plugins/i18n'
import { ref, watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: ['defaultColumns', 'defaultKey'],
  emits: ['submit'],
  setup(__props, { emit: emits }) {

const props = __props


const tableRef = ref()
const toolRef = ref()
const selectRowKey = ref([])

const close = () => {
  toolRef.value.onClose()
}
const handleSelectionChange = (data: any) => {
  console.log(data)
  selectRowKey.value = data.map((v: any) => v.prop)
}
const handleClick = () => {
  emits('submit', selectRowKey.value)
  close()
}
const showTool = () => {
  props.defaultColumns.forEach((v:any) => {
    if (!props.defaultKey?.length || props.defaultKey?.includes(v.prop)) {
      tableRef.value.toggleRowSelection(v, true)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    effect: "light",
    placement: "right",
    onShow: showTool,
    ref: (_value, _refs) => {
      _refs['toolRef'] = _value
      toolRef.value = _value
    },
    trigger: "click"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('表格筛选')), 1),
        _createVNode(_component_el_table, {
          height: "400",
          ref: (_value, _refs) => {
            _refs['tableRef'] = _value
            tableRef.value = _value
          },
          onSelectionChange: handleSelectionChange,
          data: __props.defaultColumns,
          rowKey: "prop",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55",
              "reserve-selection": true
            }),
            _createVNode(_component_el_table_column, {
              prop: "label",
              label: _unref(t)('标题1'),
              noLazyChildren: "",
              width: "180"
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, { onClick: close }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: handleClick,
              disabled: !selectRowKey.value.length
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('表格筛选')), 1)
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})